/**
 * Client for the Archer backend API.
 * The Archer backend sits between the SPA and Omniapps Account/AI gateways.
 * This client is the only thing the frontend talks to for project data.
 */
export class ArcherApiClient {
    baseUrl;
    authHeaderProvider;
    constructor(baseUrl, authHeaderProvider) {
        this.baseUrl = baseUrl;
        this.authHeaderProvider = authHeaderProvider;
    }
    async me() {
        return this.request('GET', '/me');
    }
    // -------- projects --------
    async listProjects() {
        return this.request('GET', '/projects');
    }
    async getProject(id) {
        return this.request('GET', `/projects/${id}`);
    }
    async createProject(name, file) {
        return this.request('POST', '/projects', { name, file });
    }
    async updateProject(id, file) {
        return this.request('PUT', `/projects/${id}`, { file });
    }
    async deleteProject(id) {
        await this.request('DELETE', `/projects/${id}`);
    }
    // -------- sharing --------
    async listInvites(projectId) {
        return this.request('GET', `/projects/${projectId}/invites`);
    }
    async createInvite(projectId, role, expiresInDays) {
        return this.request('POST', `/projects/${projectId}/invites`, { role, expiresInDays });
    }
    async revokeInvite(projectId, token) {
        await this.request('DELETE', `/projects/${projectId}/invites/${token}`);
    }
    async resolveInvite(token) {
        return this.request('GET', `/invites/${token}`);
    }
    async acceptInvite(token) {
        return this.request('POST', `/invites/${token}/accept`);
    }
    async listCollaborators(projectId) {
        return this.request('GET', `/projects/${projectId}/collaborators`);
    }
    // -------- AI --------
    async listAiModels() {
        return this.request('GET', '/ai/models').then((r) => r.models);
    }
    async generateMermaid(prompt, model, apiKey) {
        return this.request('POST', '/ai/diagram', { prompt, model, apiKey });
    }
    async request(method, path, body) {
        const headers = {
            'Content-Type': 'application/json',
            ...(await this.authHeaderProvider()),
        };
        const url = `${this.baseUrl}${path}`;
        if (typeof console !== 'undefined') {
            console.debug(`[archer-api] ${method} ${url}`);
        }
        const res = await fetch(url, {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined,
        });
        if (!res.ok) {
            const err = (await res.json().catch(() => ({})));
            throw new Error(err.message ?? err.error ?? `${method} ${path} failed: ${res.status}`);
        }
        if (res.status === 204)
            return undefined;
        return (await res.json());
    }
}
//# sourceMappingURL=archer-api.js.map